<template>
  <atomic-image
    src="/img/circle-preloader.svg"
    class="atomic-btn-preloader"
  />
</template>

<style src="~/assets/styles/components/atomic/btn-preloader.scss" />
